import type { Product } from "@optymyse/suite-id";
import { PRODUCTS, type ProductKey } from "@optymyse/suite-ui/door";

/**
 * Link, the app: an organisation's directory at Link, its companies and contacts, for the people of a workspace. It is
 * one of Optymyse ID's apps, by the key Impa knows it by (its `products.key`), which is its Impa client's id too
 * (wrangler.toml's ID_CLIENT_ID). Every use of the key in the app's code is this one constant.
 *
 * The key is `link` (the owner's choice of 23 October 2026), so its Impa credentials are `link-control` and
 * `link-people` and its credential at Link `link-directory`, as every product's are named for its key. The Worker
 * keeps its own name, `link-app`, as Steer's is `steer-app`, beside `link-api`, Link's own: neither is the key.
 *
 * SuiteId (since 0.10.0) and SuiteUi (since 0.16.0) both name it, which `satisfies` holds the key to: Link's name,
 * mark, colour and place among the suite's apps are the kit's, as every app's are.
 */
export const PRODUCT_KEY = "link" satisfies Product & ProductKey;

/** The app's name, as the kit names it: Link ("Link by Optymyse"). */
export const APP_NAME = PRODUCTS[PRODUCT_KEY].name;
